import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import "./LanguageSwitcher.css";

export default function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();
  return (
    <div className="language-switcher" role="group" aria-label={t("Language")}>
      <button
        type="button"
        lang="en"
        aria-label="English"
        aria-pressed={language === "en"}
        onClick={() => setLanguage("en")}
      >
        EN
      </button>
      <button
        type="button"
        lang="pt-PT"
        aria-label="Português (Portugal)"
        aria-pressed={language === "pt"}
        onClick={() => setLanguage("pt")}
      >
        PT
      </button>
    </div>
  );
}
